<template>

  <v-container fluid v-if="hotel">

    <v-row no-gutters align="center">
      <h1 class="display-1 ma-3 grey--text text--darken-2">{{hotel.name}}</h1>
      <v-rating v-model="hotel.static.general.classification.level" readonly dense/>
    </v-row>

    <v-row no-gutters class="pa-2">
      <v-col cols="12" md="8">
        <v-row no-gutters>
          <v-col cols="12" md="6">
            <im-hotel-description :hotel="hotel" @save="save" @cancel="cancel"/>
          </v-col>
          <v-col cols="12" md="6">
            <v-row no-gutters>
              <v-col cols="12">
                <im-hotel-contact :hotel="hotel" @save="save" @cancel="cancel"/>
              </v-col>
              <v-col cols="12">
                <im-hotel-address :hotel="hotel" @save="save" @cancel="cancel"/>
              </v-col>
              <v-col cols="12">
                <im-hotel-suppliers :hotel="hotel" @save="save" @cancel="cancel"/>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <im-hotel-policies :hotel="hotel" @save="save" @cancel="cancel"/>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row no-gutters>
          <v-col cols="12">
            <im-hotel-media :hotel="hotel" @save="save" @cancel="cancel"/>
          </v-col>
          <v-col cols="12">
            <im-hotel-facilities :hotel="hotel" @save="save" @cancel="cancel"/>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

  </v-container>

</template>

<script>

  import hotel_repository from '@/repositories/hotel-repository'

  export default {

    components: {
      'im-hotel-description': () => import('@/components/Hotel/DescriptionCard'),
      'im-hotel-contact': () => import('@/components/Hotel/ContactCard'),
      'im-hotel-address': () => import('@/components/Hotel/AddressCard'),
      'im-hotel-facilities': () => import('@/components/Hotel/FacilitiesCard'),
      'im-hotel-policies': () => import('@/components/Hotel/PoliciesCard'),
      'im-hotel-suppliers': () => import('@/components/Hotel/SupplierCard'),
      'im-hotel-media': () => import('@/components/Hotel/MediaCard')
    },

    data: () => ({
      hotel: null
    }),

    async created() {
      try {
        this.hotel = await hotel_repository.getHotel(this.$route.params.hotel);
      } catch (e) {
        await this.$store.dispatch('alert/error', e)
      }
    },

    methods: {

      async save() {
        try {
          this.hotel = await hotel_repository.saveHotel(this.hotel);
          await this.$store.dispatch('alert/success', 'Success');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        }
      },

      async cancel() {
        try {
          this.hotel = await hotel_repository.getHotel(this.$route.params.hotel);
          await this.$store.dispatch('alert/warning', 'Modificăriile au fost anulate.');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        }
      }

    }

  }
</script>

